export type UserRoleCode = 'super' | 'admin';

export const CLIENT_ROUTE = '/customers';
export const API_ROUTE = '/api/customer'
export const CLIENT_TITLE = 'Апп хэрэглэгч'

export const roleCodes: UserRoleCode[] = [
    'admin',
    'super'
]